module.exports = __webpack_public_path__ + "img/injection.bb9042f9.jpg";